import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { EntityInformation } from '../models/entity-information.model';
import { MalihuScrollbarDirective } from 'ngx-malihu-scrollbar';
import { GlobalConfig } from 'src/app/core/config.model';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { FocusMeDirective } from 'src/app/core/focus-me/focus-me.directive';
import { CloneService } from 'src/app/core/services/clone.service';
import { from, Observable, of, OperatorFunction } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-entity-edit',
  templateUrl: './entity-edit.component.html',
  styles: [
  ]
})
export class EntityEditComponent implements OnInit {
  @ViewChild(NgForm) newAccountForm!: NgForm;

  @Input('entity-id') entityId: string;
  @Input('parent-id') parentId: string;
  @Input('save-callback') saveCallback: () => void;
  @Input('cancel-callback') cancelCallback: () => void;

  submitAttempt: boolean = false;
  accountInfo: EntityInformation;
  lastSaved: EntityInformation;
  scrollbarOptions = GlobalConfig.scrollbarOptions;
  stateList = PDxLists.AbbreviatedStates();

  constructor(private dirtyService: DirtyTrackingService,
    private cloneService: CloneService,
    private confirmService: ConfirmService,
    private router: Router,
    private ajax: ajaxCall) { }

  ngOnInit(): void {
    if (this.entityId) {
      this.ajax.MakeCall<EntityInformation>('/Entity/Get', { entityId: this.entityId }).then((data) => {
        this.accountInfo = data;
        this.lastSaved = this.cloneService.deepClone(this.accountInfo);
      }, () => { });
    } else {
      this.accountInfo = new EntityInformation();
      this.accountInfo.isActive = true;
      this.accountInfo.parentId = this.parentId;
      this.accountInfo.state = null;
    }
  }

  cancel(): void {
    if (this.dirtyService.isClean()) {
      this.accountInfo = this.cloneService.deepClone(this.lastSaved);
      this.cancelCallback();
    }
  }

  saveAccount(): void {
    this.submitAttempt = true;
    if (this.newAccountForm.invalid) {
      return;
    }
    this.ajax.MakeCall<EntityInformation>('/Entity/Save', this.accountInfo).then((data) => {
      this.accountInfo = data;
      this.lastSaved = this.cloneService.deepClone(this.accountInfo);
      this.submitAttempt = false;
      this.newAccountForm.form.markAsPristine();
      this.saveCallback();
    }, () => { });
  }

  searchSpecialty: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => { }),
      switchMap(term => {
        if (!term) {
          return of([]);
        }
        return from(this.ajax.MakeCall<string[]>('/Entity/Specialties', { query: term }, false)).pipe(
          catchError(() => {
            return of([]);
          }))
      }),
      tap(() => { }),
    )

  deleteEntity(): void {
    this.confirmService.delete('Delete Entity?', 'Are you sure that you want to completely delete this entity?').then(() => {
      this.ajax.MakeCall<string[]>('/Entity/Delete', { entityId: this.entityId }).then((hierarchy) => {
        hierarchy.splice(0, 0, '/manage/entities');
        this.router.navigate(hierarchy);
      }, () => { });
    }, () => { });
  }
}
